module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'disabled-scroll': _vm.loading
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }, {
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "loading",
    attrs: {
      "element-loading-text": "Đang tải dữ liệu vui lòng đợi..."
    }
  }), _vm._v(" "), (_vm.isLogged) ? _c('div', [_c('gs-menu')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-container"
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('router-view')], 1)], 1)]), _vm._v(" "), (_vm.devTool) ? _c('button', {
    staticClass: "ui icon mini button red dev-tool",
    on: {
      "click": function($event) {
        _vm.dialogDebug = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bug"
  })]) : _vm._e(), _vm._v(" "), (_vm.devTool) ? _c('div', {
    staticClass: "debug"
  }, [_c('el-dialog', {
    attrs: {
      "title": "Debug queries",
      "visible": _vm.dialogDebug,
      "fullscreen": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogDebug = $event
      }
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.debugQuery,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(debugScope) {
        return [(debugScope && debugScope.row) ? _c('table', {
          staticClass: "table"
        }, [_c('thead', [_c('tr', {
          staticClass: "debug-text"
        }, [_c('th', [_vm._v("Query")]), _vm._v(" "), _c('th', [_vm._v("File")]), _vm._v(" "), _c('th', [_vm._v("Execute time")])])]), _vm._v(" "), _c('tbody', _vm._l((debugScope.row.statements), function(statement) {
          return _c('tr', {
            staticClass: "debug-text cursor-pointer",
            on: {
              "click": function($event) {
                return _vm.showDebugDialog(statement)
              }
            }
          }, [_c('td', [_vm._v(_vm._s(statement.sql))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(statement.stmt_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(statement.duration_str))])])
        }), 0)]) : _vm._e()]
      }
    }], null, false, 978880545)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "60",
      "label": "Method",
      "prop": "method",
      "class-name": "debug-text"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Url",
      "prop": "uri",
      "class-name": "debug-text"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "File",
      "prop": "file",
      "class-name": "debug-text"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Middleware",
      "prop": "middleware",
      "width": "200",
      "class-name": "debug-text"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "60",
      "label": "Memory",
      "prop": "memory",
      "class-name": "debug-text"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "80",
      "label": "Execute time",
      "prop": "accumulated_duration_str",
      "class-name": "debug-text"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "60",
      "label": "Queries",
      "prop": "nb_statements",
      "class-name": "debug-text"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Debug query params",
      "visible": _vm.dialogDebugQuery
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogDebugQuery = $event
      }
    }
  }, [_c('pre', {
    staticClass: "debug-text"
  }, [_vm._v(_vm._s(_vm.dialogData))])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-bd26cd6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 733
// module chunks = 1